import { DispatchEvent } from "@/common/util/event";


export const feedbackInfoAction = new DispatchEvent();